import axios from 'axios'

class AuthService {
  /**
   * Verifica el estado de autenticación del usuario
   */
  async checkAuthStatus() {
    try {
      const response = await axios.get('/api/Auth/Status')
      return response.data
    } catch (error) {
      console.error('Error al verificar estado de autenticación:', error)
      throw error
    }
  }

  /**
   * Limpia la sesión en el backend
   */
  async clearBackendSession() {
    try {
      const response = await axios.get('/api/Auth/ClearSession', {
        withCredentials: true // Equivalente a credentials: 'include'
      })
      return response.status === 200
    } catch (error) {
      console.error('Error al limpiar sesión en backend:', error)
      return false
    }
  }

  /**
   * Realiza logout completo incluyendo Azure AD
   */
  forceLogout() {
    // Usar la baseURL de axios en lugar de process.env
    const baseURL = axios.defaults.baseURL.replace(/\/$/, '') // Quitar slash final
    window.location.href = `${baseURL}/api/Auth/ForceLogout`
  }

  /**
   * Inicia el proceso de login con Microsoft
   */
  loginWithMicrosoft() {
    // Usar la baseURL de axios en lugar de process.env
    const baseURL = axios.defaults.baseURL.replace(/\/$/, '') // Quitar slash final
    const loginUrl = `${baseURL}/api/Auth/Login`
    window.location.href = loginUrl
  }

  /**
   * Proceso completo de logout
   */
  async performLogout() {
    try {
      // Limpiar sesión en el backend
      await this.clearBackendSession()
      
      // Esperar un momento para que se procese
      await new Promise(resolve => setTimeout(resolve, 500))
      
      // Realizar logout completo
      this.forceLogout()
    } catch (error) {
      console.error('Error durante el logout:', error)
      // Aunque falle, intentar logout forzado
      this.forceLogout()
    }
  }
}

export default new AuthService()
